(function($) {
  "use strict";
// let's go...
// ======================================================================================================



/*------------------------------------*\
    #document.ready
\*------------------------------------*/
$(document).ready(function() {

    /*------------------------------------*\
        #full height intro
    \*------------------------------------*/
    $(window).bind('ready load resize orientationchange', function() {
        var windowHeight = $(window).height();
        $('.js-fullscreen').height(windowHeight);
    });


    /*------------------------------------*\
        #Header stuck
    \*------------------------------------*/
    $(window).scroll(function(){
        var a = 100;
        if ( $(window).scrollTop()>=a) {
            $("body").addClass('is-scrolled');
        } else {
            if ($(window).scrollTop()<a) {
                $("body").removeClass('is-scrolled');
            }
        }
    });


    /*------------------------------------*\
        #Sticky elements
    \*------------------------------------*/
    $('.js-sticky').theiaStickySidebar({
        additionalMarginTop: 95
    });



    /*------------------------------------*\
        #Widow fix
    \*------------------------------------*/
    $('.js-widowfix').widowFix();


    /*------------------------------------*\
        #Stellar (paralax)
    \*------------------------------------*/
    $(function(){
        $.stellar();
    });


    /*------------------------------------*\
        #Show/hide menu
    \*------------------------------------*/
    $(document).on('click', '.js-showmenu', function(e){
        e.preventDefault();
        $('body').toggleClass('is-menuopen');
    });


    /*------------------------------------*\
        #Flickity sliders
    \*------------------------------------*/
    /* intro slider */
    $('.js-introslider').flickity({
        contain              : true,
        prevNextButtons      : false,
        pageDots             : true,
        autoPlay             : 7000,
        pauseAutoPlayOnHover : false,
        wrapAround           : true,
        imagesLoaded         : true,
    });
    // previous
    var $introslider_previousButton = $('.js-introslider-prev').on( 'click', function(e) {
        e.preventDefault();
        $('.js-introslider').flickity('previous');
    });
    // next
    var $introslider_nextButton = $('.js-introslider-next').on( 'click', function(e) {
        e.preventDefault();
        $('.js-introslider').flickity('next');
    });


    $('.js-productslider').flickity({
        contain         : true,
        prevNextButtons : false,
        pageDots        : false,
        wrapAround      : true,
        adaptiveHeight  : true,
        imagesLoaded    : true,
    });
    // previous
    var $productslider_previousButton = $('.js-productslider-prev').on( 'click', function(e) {
        e.preventDefault();
        $('.js-productslider').flickity('previous');
    });
    // next
    var $productslider_nextButton = $('.js-productslider-next').on( 'click', function(e) {
        e.preventDefault();
        $('.js-productslider').flickity('next');
    });


    $('.js-productcarousel').flickity({
        asNavFor        : '.js-productslider',
        contain         : true,
        prevNextButtons : false,
        pageDots        : false,
        imagesLoaded    : true,
    });
    // previous
    var $productcarousel_previousButton = $('.js-productcarousel-prev').on( 'click', function(e) {
        e.preventDefault();
        $('.js-productcarousel').flickity('previous');
    });
    // next
    var $productcarousel_nextButton = $('.js-productcarousel-next').on( 'click', function(e) {
        e.preventDefault();
        $('.js-productcarousel').flickity('next');
    });




});
// ----------------------------------
// END - document.ready



//  Responsive js (https://github.com/ten1seven/jRespond)
//  ======================================================
var jRes = jRespond([
    {
        label : 'phone',
        enter : 0,
        exit  : 767
    },{
        label : 'tab',
        enter : 768,
        exit  : 991
    },{
        label : 'lap',
        enter : 992,
        exit  : 1199
    },{
        label : 'desk',
        enter : 1200,
        exit  : 10000
    }
]);

jRes.addFunc([
    {
        breakpoint: ['phone'],
        enter : function() {},
        exit  : function() {}
    },{
        breakpoint: ['tab'],
        enter : function() {

        },
        exit  : function() {}
    },{
        breakpoint: ['lap'],
        enter : function() {},
        exit  : function() {}
    },{
        breakpoint: ['desk'],
        enter : function() {},
        exit  : function() {}
    },{
        breakpoint: ['lap', 'desk'],
        enter : function() {},
        exit  : function() {}
    },{
        breakpoint: ['tab', 'lap', 'desk'],
        enter : function() {
            $('body').removeClass('is-menuopen');
        },
        exit  : function() {
            $('body').removeClass('is-scrolled');
        }
    }
]);
//  END - Responsive js
//  ======================================================



// ======================================================================================================
// the end
})(jQuery);